<template>
	<div class="main-content">
		<Breadcrumb class="bread">
			<BreadcrumbItem class="main-title">{{$t('聯絡我們')}}</BreadcrumbItem>
		</Breadcrumb>
		<Card>
			<div class="contact-info" v-html="contactInfo"></div>
		</Card>
	</div>
</template>
<script>
export default {
	data() {
		return {
			contactInfo: '',
		}
	},
	async created() {
		this.getContactInfo()
	},
	methods: {
		async getContactInfo() {
			try {
				let response = await this.$http.get('api/ContactInfo')
				this.contactInfo = response.data.Message
			} catch (error) {
				console.log(error)
			}
		},
	},
}
</script>
<style scoped>
.contact-info {
	margin: 0 10px;
}
</style>
>
